export const THRESHOLD = 0.3;

/**
 * The palette of background colors a beautified tag can resolve to. The custom
 * (stored) tag color is matched to the closest of these via `getClosestColor`.
 * These hex values mirror the tractor design tokens previously read through
 * `useColor` (secondary-800, informative-500/600, warning-500, critical-300/500/700,
 * primary-300/600, decorative1-300, decorative2-700, informative-100).
 */
export const TAG_COLORS = [
  "#253942",
  "#307FE2",
  "#2766B5",
  "#FCBB26",
  "#FF9D88",
  "#FF5C39",
  "#BB2100",
  "#66D1B8",
  "#008F6D",
  "#AFA5EF",
  "#EB5E7C",
  "#D3E2F6",
];
